import React, { useEffect, useState } from 'react'
import MyInput from '../../components/MyComponent/MyInput'
import SearchableSelect from '../../components/AppSelect/SearchableSelect'
import { expenseCategory, paymentMethod } from '../../constant/Options'
import { useDispatch, useSelector } from 'react-redux'
import { HitApi } from '../../Api/ApiHit'
import { addExpense, searchExpense, updateExpense } from '../../constant/Constant'
import AppButton from '../../components/AppButton/AppButton'
import { useNavigate, useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { setDataAction } from '../../redux/Actions/SetDataAction'
import { SET_API_JSON } from '../../redux/ActionName/ActionName'
import DatePicker from '../../components/DatePicker/DatePicker'

const AddExpense = () => {

    const ApiReducer = useSelector(state => state.ApiReducer)
    console.log("ApiReducer ankit", ApiReducer);
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { id } = useParams()

    useEffect(() => {
        if (id) {
            loadServey()
        }
    }, [id])

    const loadServey = () => {
        const json = {
            page: 1, limit: 10, search: {
                _id: id
            }
        }
        HitApi(json, searchExpense).then((res) => {
            console.log("res for edit", res?.data?.docs[0]);
            if (res?.status === 200) {
                dispatch(setDataAction(res?.data?.docs[0], SET_API_JSON))
            }
        })
    }




    const addExpenseData = () => {
        const json = {
            ...(id && { _id: id }),
            payee: ApiReducer?.apiJson?.payee,
            recieptNumber: ApiReducer?.apiJson?.recieptNumber,
            amount: ApiReducer?.apiJson?.amount,
            category: ApiReducer?.apiJson?.category,
            mode: ApiReducer?.apiJson?.mode,
            date: ApiReducer?.apiJson?.date,
            remark: ApiReducer?.apiJson?.remark,
        }


        HitApi(json, id ? updateExpense : addExpense).then((res) => {
            console.log("res", res);
            if (res?.statusCode === 201) {
                toast.success("Expense Added Successfully")
                navigate("/expense")
            }
            else if (res?.statusCode === 200) {
                toast.success("Expense Updated Successfully")
                navigate("/expense")
            }
        })
    }


    return (
        <div className='p-4'>
            <div className='grid grid-cols-3 gap-4'>
                <MyInput title={"Receipt No."} name='recieptNumber' type={"number"} />
                <MyInput title={"Payee"} name='payee' />
                <MyInput title={"Amount"} name='amount' type={"number"} />
                <MyInput title={"Remark"} name='remark' />
                <DatePicker title='Date' name='date' />
                <SearchableSelect
                    title="Select Category"
                    name="category"
                    options={expenseCategory}
                    important={true}
                    placeholder="Select mode"
                />
                <SearchableSelect
                    title="Select Mode"
                    name="mode"
                    options={paymentMethod}
                    important={true}
                    placeholder="Select mode"
                />
            </div>
            <div>
                <AppButton
                    buttontext={id ? "Update Expense" : " + Add Expense"}
                    onClick={addExpenseData}
                    className="bg-gray-100 hover:bg-gray-200 border-2 border-gray-300 hover:border-gray-400 text-gray-700 font-medium px-6 py-3 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
                />
            </div>
        </div>
    )
}

export default AddExpense